module.exports = __webpack_public_path__ + "assets/img/reverse-sweep-4.4d3af846.jpg";